// hydras in JSON-LD response
export const HYDRA_MEMBER = 'hydra:member';
export const HYDRA_TOTAL_ITEMS = 'hydra:totalItems';
export const HYDRA_DESCRIPTION = 'hydra:description';
